<div class="panel panel-default" [class.backgroundColorError]="invalid">
    <div class="panel-heading clearfix pointer" data-toggle="collapse" [attr.data-target]="'#collPn' + id"
        (click)="togglePanelOpen()">
        <h5 class="panel-title">
            <i class="fas fa-sticky-note"></i>
            <strong>{{ title }}</strong>
            <i class="collapse-icon fas pull-right"
                [ngClass]="{ 'fa-caret-down': !isPanelOpen, 'fa-caret-up': isPanelOpen}"></i>
            <strong *ngIf="rightTitle" class="pull-right margin">{{ rightTitle }}</strong>
        </h5>
    </div>
    <div [id]="'collPn' + id" class="panel-body no-horizontal-padding collapse" [class.in]="expanded">
        <ng-content></ng-content>
    </div>
</div>
